import React from 'react'
import ScrollableMenu from '../../internals/components/ScrollableMenu';
function ScrollableMenuDashboard() {
    const menuItems = [
        { label: "Koneksi & Top 3", image: "/images/menuIcons/Accumulator.png", route: "/connection" },
        { label: "Produk Mark", image: "/images/menuIcons/AirFilter.png", route: "/products" },
        { label: "Alamat Mark", image: "/images/menuIcons/Belt.png", route: "/address" },
        { label: "Marketing Kit", image: "/images/menuIcons/BrakeDisc.png", route: "/marketing-kit" },
        { label: "Pemesanan", image: "/images/menuIcons/CarBulb.png", route: "/booking" },
        { label: "List Harga", image: "/images/menuIcons/CarInsurance.png", route: "/price-list" },
        { label: "FAQ", image: "/images/menuIcons/KeyCar.png", route: "/faq" },
        { label: "Bantuan", image: "/images/menuIcons/SpeedGear.png", route: "/bantuan" }
    ];
    return (
        <ScrollableMenu
            menuItems={menuItems}
            avatarStyle={{ width: 40, height: 40 }}
            labelStyle={{ fontSize: 14, color: '#333' }}
        />
    )
}

export default ScrollableMenuDashboard